module.exports = __webpack_public_path__ + "n.no1.3b45b6e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/n.no1.jpg
// module id = 1Rnl
// module chunks = 0